import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=19a18d98"
import script from "./products-list.vue?vue&type=script&lang=js"
export * from "./products-list.vue?vue&type=script&lang=js"
import style0 from "./products-list.vue?vue&type=style&index=0&id=19a18d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports